import Format from "../components/format/Format";
import { ButtonValues } from "../types/button.type";

export default function Base64() {
    const buttons:ButtonValues[] = [
        {
            api: '/api/base64/encode',
            buttonLabel: 'Encode',
            outputLabel: 'Encoded',
        },
        {
            api: '/api/base64/decode',
            buttonLabel: 'Decode',
            outputLabel: 'Decoded',
        },
    ];

    return (
        <Format inputLabel='String' buttons={buttons}/>
    );
}